import FieldDefs from './KeywordsFieldDefs'
import FieldGny from './KeywordsGny'
import {doLangFields, isGoogleGny} from '../../lib/ks-tools'
import {Listeners} from "keysso/constants/listeners";

export default {
    template: `<div><slot v-bind="self" /></div>`,
    data() {
        return {
            fields: doLangFields(this, "lang.report.keywords", isGoogleGny() ? FieldGny : FieldDefs),
            sortOrder: [
                {
                    field: '__slot:pos',
                    sortField: 'pos',
                    direction: 'asc'
                }
            ],
            additionalActions: [
                {
                    label: this.$t("lang.report.open_uniq_tools"),
                    icon: ["fa", "fa-object-ungroup"],
                    event: function(){

                        if (this.$parent.$parent.$refs.ksTable.demoTariffModal.show) {
                            this.$parent.$parent.$refs.ksTable.demoTariffModal.message = this.$t('lang.modal.demoTariffNotAllowed')
                            this.$emitter.emit(Listeners.POPUP_KS_TABLE_DEMO_OPEN);
                            return;
                        }

                        let vars = {};

                        this.$parent.$parent.$refs.ksTable.apiUrl.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
                            vars[key] = value;
                        });

                        vars['filter'] = this.getQuery();
                        vars['from'] = 'keywords';

                        window.open('/' + window.locale + '/tools/unique#' + Object.keys(vars).map(key => `${key}=${encodeURIComponent(vars[key])}`).join('&'), '_blank');
                    }
                },
                {
                    label: this.$t("lang.report.open_double_tools"),
                    icon: ["fa", "fa-trash-o"],
                    event: function(){

                        let vars = {};

                        this.$parent.$parent.$refs.ksTable.apiUrl.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
                            vars[key] = value;
                        });

                        vars['filter'] = this.getQuery();
                        vars['from'] = 'keywords';

                        window.open('/' + window.locale + '/tools/delete-double#' + Object.keys(vars).map(key => `${key}=${encodeURIComponent(vars[key])}`).join('&'), '_blank');
                    }
                },
                {
                    label: this.$t("lang.report.pages_with_keys"),
                    icon: [],
                    event: function(){
                        window.open("/" + window.locale + "/sitepageswithkeys?domain=" + this.$parent.$parent.$refs.ksTable.domainUrl, '_blank');
                    }
                }
            ],
        }
    },
    computed: {
        self() {
            return this;
        },
    },
}
